<template>
  <div class="kye-empty">
    <div :style="imageStyle">
      <slot v-if="$slots.image"
            name="image" />
      <img v-else
           :src="url"
           ondragstart="return false" />
    </div>
    <div class="kye-empty__description">
      <slot v-if="$slots.description"
            name="description" />
      <p v-else>{{ text }}</p>
    </div>
    <div></div>
  </div>
</template>

<script>
  import NoData from 'public/assets/images/no-data.png'
  import NoResults from 'public/assets/images/no-results.png'

  const mapTitle = {
    'NoData': '暂无数据',
    'NoResults': '搜索无结果'
  }

  const mapImage = {
    'NoData': NoData,
    'NoResults': NoResults
  }

  export default {
    name: 'KyeEmpty',
    props: {
      type: {
        type: String,
        default: 'NoData'
      },
      description: {
        type: String,
        default: () => mapTitle[NoData]
      },
      image: {
        type: String,
        default: () => mapImage[NoData]
      },
      imageSize: {
        type: [Number, String],
        default: 300
      }
    },
    computed: {
      imageStyle () {
        const width = this.imageSize ? parseInt(this.imageSize) + 'px' : ''
        return { width }
      },
      text () {
        return this.description || mapTitle[this.type]
      },
      url () {
        return this.image || mapImage[this.type]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kye-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    box-sizing: border-box;
    img {
      user-select: none;
      width: 100%;
      height: 100%;
      vertical-align: top;
      object-fit: contain;
    }
    &__description {
      color: #999999;
      margin-top: 12px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/public/components/kye-empty/index.vue